import { render, staticRenderFns } from "./GenAiCard.vue?vue&type=template&id=38ed9c88&scoped=true&"
import script from "./GenAiCard.vue?vue&type=script&lang=ts&"
export * from "./GenAiCard.vue?vue&type=script&lang=ts&"
import style0 from "./GenAiCard.vue?vue&type=style&index=0&id=38ed9c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ed9c88",
  null
  
)

export default component.exports